import { render } from "./SectionMain.vue?vue&type=template&id=2bbf99b3&scoped=true"
import script from "./SectionMain.vue?vue&type=script&lang=js"
export * from "./SectionMain.vue?vue&type=script&lang=js"

import "./SectionMain.vue?vue&type=style&index=0&id=2bbf99b3&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbf99b3"]])

export default __exports__